import React from 'react';
import { Typography } from '@/lib/typography';
import { Clock } from '@phosphor-icons/react';
import { WORK_TYPES } from '@/config/task-display-config';

export function ActivityFeed() {
  // Mock data - matches final DTO shape from §6.1
  const activity = {
    events: [
      {
        ts: "2025-10-24T11:20:00Z",
        entity_type: "startup",
        entity_id: "001",
        action: "status_changed",
        summary: "Healthcare Innovations 1 → Warm"
      },
      {
        ts: "2025-10-24T10:30:00Z",
        entity_type: "campaign", // noscan
        entity_id: "002",
        action: "batch_sent",
        summary: "Outreach Task Generated"
      },
      {
        ts: "2025-10-23T16:45:00Z",
        entity_type: "startup",
        entity_id: "003",
        action: "status_changed",
        summary: "Education Innovations 2 → Mandated"
      },
      {
        ts: "2025-10-23T14:20:00Z",
        entity_type: "kb",
        entity_id: "004",
        action: "article_published",
        summary: "New article: AI in Healthcare"
      },
      {
        ts: "2025-10-22T09:15:00Z",
        entity_type: "idea",
        entity_id: "005",
        action: "promoted",
        summary: "Idea 'Fintech for SMBs' promoted to campaign"
      }
    ]
  };

  const formatTimestamp = (ts) => {
    const date = new Date(ts);
    const now = new Date();
    const diffMs = now - date;
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffHours < 1) return 'Just now';
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays === 1) return 'Yesterday';
    return `${diffDays}d ago`;
  };

  const getEntityColor = (entityType) => {
    const colors = {
      startup: 'bg-brand-100 text-brand-700',
      [WORK_TYPES.CAMPAIGN]: 'bg-amber-100 text-amber-700',
      kb: 'bg-brand-100 text-brand-950',
      idea: 'bg-slate-50 text-green-700'
    };
    return colors[entityType] || 'bg-slate-50 text-slate-700';
  };

  return (
    <div className="bg-white rounded-lg border border-brand-100 p-6">
      <h2 className={Typography.h2}>
        Recent Activity
      </h2>

      {activity.events.length === 0 ? (
        <div className="text-center py-8">
          <Clock className="w-12 h-12 text-slate-500 mx-auto mb-3 opacity-50" />
          <p className="text-slate-500">No recent activity</p>
        </div>
      ) : (
        <div className="space-y-4">
          {activity.events.map((event, index) => (
            <div key={index} className="flex items-start gap-3 pb-4 border-b border-brand-100 last:border-0 last:pb-0">
              <span className={`px-2 py-1 text-xs font-medium rounded-lg ${getEntityColor(event.entity_type)}`}>
                {event.entity_type}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-brand-950">
                  {event.summary}
                </p>
                <p className="text-slate-500 mt-1">
                  {formatTimestamp(event.ts)}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
